import { signOut } from "@/contexts/AuthContext";
import { isPublicPage } from "./api.constants";

export function validateAuthOrSignOut(): string | null {
  const token = localStorage.getItem("barte-auth-token");
  if (!token && !isPublicPage(window.location.pathname)) {
    signOut();
    return null;
  }
  return token;
}
